import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
import R1 from './img/r1.png';
import R2 from './img/r2.png';
import R3 from './img/r3.png';
import R4 from './img/r4.png';
import R5 from './img/r5.png';
import R6 from './img/r6.png';
import CoreValues from './img/core.jpg';
import HistoryData from "./data/history.json";
class Rotaract extends Component {

  componentWillMount(){


  }

  render() {
    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>
              <div className="AboutUsImage">
                <Image className="AboutUsImage" src={R1} />
              </div>
                <div className="AboutUsTitle">
                  About Rotaract Club of Central
                </div>

                <div className="AboutUsText left">
                Since our chartering in 2017, Rotaract Club of Central (“RAC Central”), sponsored by Rotary Club of Central, has held an array of workshops, events and service projects for our members to serve, to learn, and to lead.
<br/><br/>
Our club embraces energetic young people from diverse backgrounds in hopes of cultivating a positive and an enlightened way to life.
<br/><br/>
RY2018-2019 Theme: 啟航 Bon Voyage <br/>
Values: Service, Fellowship, Diversity <br/>
Motto: Fellowship through Service <br/>
Slogan: To serve, To learn, To lead<br/>
<br/><br/>
To know more, please visit our Facebook Page at https://www.facebook.com/raccentral/.

                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={R2} /><Image className="col-12 col-sm-6 col-md-3" src={R3} />
                </div>
                <div className="AboutUsImage row justify-content-center">
                  <Image className="col-12 col-sm-6 col-md-3" src={R4} /><Image className="col-12 col-sm-6 col-md-3" src={R5} /><Image className="col-12 col-sm-6 col-md-3" src={R6} />
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default Rotaract;
